import React from 'react'
import { Layout, Header } from 'app/theme/layout'
import { Helmet } from 'react-helmet-async'
import ImageHero from 'app/theme/ImageHero'
import { OccasionPageGrid, OccasionPageGridRow } from './shared/OccasionPageGrid'
import getGoogleMetaTags from './occasionSEOData'
import conferenceCatering1 from 'assets/img/conference-catering-1.jpg'
import conferenceCatering2 from 'assets/img/conference-catering-2.jpg'
import conferenceCatering3 from 'assets/img/conference-catering-3.jpg'
import conferenceCatering4 from 'assets/img/conference-catering-4.jpg'
import conferenceCateringBanner from 'assets/img/conference-catering-hero.jpg'
import Calculator from 'app/theme/calculator'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import OccasionsSlider from 'app/theme/sections/CateringOccasionsSlider'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import NavbarFixed from 'app/theme/NavbarFixed'
import { useInView } from 'react-intersection-observer'

export default function ConferenceCateringPage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    rootMargin: '1px',
    initialInView: true,
  })

  const googleMetaTags = getGoogleMetaTags('conference')


  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Food Truck Conference and Event Catering - Roaming Hunger</title>
        <meta name="og:title" content="Food Truck Conference and Event Catering"></meta>
        <meta name="description" content="Food trucks are a great foodservice option for your conference, or convention. Our venders offer full service catering including breakfast, lunch, and dinner."></meta>
        <script type="application/ld+json">
          {googleMetaTags}
        </script>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={conferenceCateringBanner}
          title="Professional Events"
          onButtonClick={openModal}
          description="Looking to feed an entire conference or convention of people? After a long day of walking, talking, and networking, your attendees, clients, and partners will love bonding over a savory and delicious meal from an amazing food truck."
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}
      <IntroGrid />
      <FeaturedClients onButtonClick={openModal} />
      <GridSection2 />
      <CuisineTypes baseUrl='/food-truck-catering' />
      <HowItWorks heading="How Professional Event Catering Works" onButtonClick={openModal} />
      <HowItWorksLarge heading="How Professional Event Catering Works" onButtonClick={openModal} />
      <Calculator onButtonClick={openModal} />
      <OccasionsSlider className="bg-white py-12" heading="Other catering occasions" onButtonClick={openModal} />
    </Layout>
  )
}

function IntroGrid() {
  return (
    <OccasionPageGrid className="py-10">
      <OccasionPageGridRow
        heading="Experts In Easy Food Service"
        content="Focus on executing a successful event and leave the foodservice to us. We are experts in securing the food trucks and handling all the paperwork, including obtaining W9s, COIs, business permits, and truck payments."
        image={conferenceCatering1}
        reverse
      />
      <OccasionPageGridRow
        heading="Cuisine For Any Occasion"
        content="Keep your attendees well-fed and happy throughout your conference or convention. We offer countless mouthwatering food options for breakfast, lunch, or dinner from thousands of popular food trucks."
        image={conferenceCatering2}
      />
    </OccasionPageGrid>
  )
}

function GridSection2() {
  return (
    <OccasionPageGrid className="py-10">
      <OccasionPageGridRow
        heading="Service Guarantee"
        content="Our established relationships with reliable food trucks allow you to book with confidence. Funds are held in escrow for the vendor until after the event, so you know your attendees will get the best customer service experience."
        image={conferenceCatering3}
        reverse
      />
      <OccasionPageGridRow
        heading="No Mess, No Stress"
        content="Go above and beyond traditional catering. Food trucks have the ability to set up and serve almost anywhere, and when your conference ends, watch the mess drive away. It's gourmet goodness without any of the hassle."
        image={conferenceCatering4}
      />
    </OccasionPageGrid>
  )
}
